/* SVADEZI — PDP: hero image follows the selected metal colour.

   Picking Rose or Rhodium used to leave the yellow-gold packshot on screen, so
   the one control whose entire purpose is to change how the piece looks changed
   nothing visible. This swaps the main gallery image to the matching colour and
   moves the thumbnail strip's active marker with it.

   HOW A PHOTO IS MATCHED TO A COLOUR
   The catalogue has a reliable convention, verified on both option layouts:
       alt  "Majestic Allure Diamond Ring by SVADEZI - rhodium"
       file rhodium-image-1_8c735a20-....png
   Colour-neutral shots (model, all-variants, scale, certificate) carry no
   suffix and are therefore never auto-selected. Alt text is the primary key and
   the filename is the fallback, because alt is authored data and survives a
   re-upload that changes the CDN filename.

   NOT EVERY COLOUR HAS A PHOTO. svadezi-gr-8951-p12 sells Rose but ships only
   yellow and rhodium images. When there is no match we leave the current image
   alone — showing the wrong metal is worse than showing a colour-neutral one,
   and blanking the stage is worse than both.

   IT ALSO CORRECTS THE FIRST PAINT. Liquid renders product.featured_image,
   which is whatever the merchant flagged — on svadezi-gr-8951-p12 that is the
   yellow packshot, while the default variant is "14 KT Rhodium". So the page
   loaded showing yellow with Rhodium selected. sync() therefore runs on init
   rather than merely recording the starting colour.

   WHY IT LISTENS THE WAY IT DOES
   `data-opt-kind` is applied by pdp-lovable.js at runtime, not by Liquid, so
   this file must load after it (see the comment in layout/theme.liquid). Two
   layouts have to be read:
     · separate options  -> [data-opt-kind="finish"] input:checked  ("Rose Gold")
     · fused purity+colour -> a synthesised .opt-synth group whose pills are
       <button aria-pressed>, which tick a hidden real radio and dispatch a
       bubbling change. One delegated listener on the form catches both, plus a
       click listener for the synthesised buttons.
   Last resort is the compound value itself ("925 Silver Yellow Plated"), which
   still names the colour.

   It never touches the variant id, the price, or the form. Purely presentational.
*/
(function () {
  var main = document.querySelector('[data-gallery-main]');
  var form = document.getElementById('pdp-form');
  if (!main || !form) return;

  var strip = document.querySelector('.gallery-thumbs');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
  if (!thumbs.length) return;

  /* Rhodium and white are the same physical finish in this catalogue: rhodium
     plating photographs as white gold. Both map to one bucket. */
  function normalise(text) {
    var v = String(text || '').toLowerCase();
    if (/rhodium|white|platinum/.test(v)) return 'rhodium';
    if (/rose|pink/.test(v)) return 'rose';
    if (/yellow/.test(v)) return 'yellow';
    return null;
  }

  function colourOfThumb(btn) {
    // alt convention: trailing " - <colour>" (hyphen or en dash)
    var alt = (btn.getAttribute('data-alt') || '').toLowerCase();
    var m = alt.match(/[-–]\\s*(yellow|rose|rhodium|white)\\s*$/);
    if (m) return normalise(m[1]);
    // filename convention: the colour is the leading token
    var file = (btn.getAttribute('data-src') || '').split('/').pop().toLowerCase();
    if (/^(yellow|rose|rhodium|white)[-_]/.test(file)) return normalise(file.split(/[-_]/)[0]);
    return null;
  }

  /* First match in media order wins, which is the packshot: media is ordered
     <colour>-image-1 before <colour>-studio-1 on every product checked. */
  var byColour = {};
  thumbs.forEach(function (b) {
    var c = colourOfThumb(b);
    if (c && !byColour[c]) byColour[c] = b;
  });
  if (!Object.keys(byColour).length) return;

  function selectedColour() {
    var group = form.querySelector('[data-opt-kind="finish"]');
    if (group) {
      var pressed = group.querySelector('.opt-pill[aria-pressed="true"]');
      if (pressed) { var a = normalise(pressed.textContent); if (a) return a; }
      var checked = group.querySelector('input:checked');
      if (checked) { var b = normalise(checked.value); if (b) return b; }
    }
    /* Fallback for a product pdp-lovable.js has not tagged: find a group whose
       label reads like a colour, rather than assuming an option position. */
    var groups = form.querySelectorAll('.opt, .opt-synth');
    for (var i = 0; i < groups.length; i++) {
      var lbl = groups[i].querySelector('.opt-label');
      if (!lbl || !/colo|finish/i.test(lbl.textContent)) continue;
      var p = groups[i].querySelector('.opt-pill[aria-pressed="true"]');
      if (p) { var c = normalise(p.textContent); if (c) return c; }
      var r = groups[i].querySelector('input:checked');
      if (r) { var d = normalise(r.value); if (d) return d; }
    }
    var comp = form.querySelector('[data-opt-kind="compound"] input:checked');
    return comp ? normalise(comp.value) : null;
  }

  /* Scroll the STRIP only, never the page. scrollIntoView() was the first
     attempt and it scrolled the document — measured a 146px jump on a colour
     change at scrollY 354 — because the strip is not always the nearest
     scrollable ancestor. Setting scrollLeft cannot move the page. */
  function revealThumb(btn) {
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    var target = btn.offsetLeft - (strip.clientWidth - btn.offsetWidth) / 2;
    var max = strip.scrollWidth - strip.clientWidth;
    strip.scrollLeft = Math.max(0, Math.min(target, max));
  }

  var applied = null;

  function show(colour) {
    if (!colour || colour === applied) return;
    var btn = byColour[colour];
    if (!btn) return;                       // no photo for this colour: leave it be
    var src = btn.getAttribute('data-src');
    if (!src) return;
    applied = colour;
    if (main.getAttribute('src') !== src) {
      main.setAttribute('src', src);
      main.alt = btn.getAttribute('data-alt') || main.alt;
    }
    // keep the strip's marker truthful
    thumbs.forEach(function (o) {
      o.setAttribute('aria-current', o === btn ? 'true' : 'false');
    });
    revealThumb(btn);
  }

  function sync() { show(selectedColour()); }

  form.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input, select')) window.setTimeout(sync, 0);
  });
  /* synthesised pills are buttons; their change event fires on the hidden radio,
     but listen to the click too so a no-op re-tick still resolves. */
  form.addEventListener('click', function (e) {
    if (e.target && e.target.closest('.opt-pill')) window.setTimeout(sync, 0);
  });

  /* A manual thumbnail click is the shopper overriding us — forget the applied
     colour so the next colour change re-applies rather than being skipped. */
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () { applied = null; });
  });

  sync();   // correct the first paint, see the note at the top of this file
})();